import { Suspense } from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '@/components/ProtectedRoute';
import RoleGuard from '@/components/RoleGuard';
import { LoadingSpinner } from '@/app/LoadingSpinner';
import { AuthRedirect, AutoRouteHome } from '@/app/redirects';
import {
  Display,
  AdminDashboardV2,
  AdminPortal,
  AuditAccess,
  Demo,
  ExercerMesDroits,
  ForceChangePassword,
  LicenseActivation,
  ResellerDetailPage,
  ResetPassword,
  ReviewRedirect,
  TenantApp,
  TenantsMonitoring,
  TpeMonitoring,
  CashRecyclerFleet,
  InstallationTools,
  TrustCenter,
  Unsubscribe,
  ZRecompute,
} from '@/app/lazyPages';

/**
 * Groupe de routes extrait d'App.tsx (strangler 1b) — ordre source préservé.
 * Table de routes déclarative : dépasse volontairement max-lines-per-function (warn).
 */
export function publicRoutes() {
  return (
    <>
      <Route path="/" element={<AutoRouteHome />} />
      <Route path="/auth" element={<AuthRedirect />} />
      {/* Écran client (lot E3) — device appairé, hors layout/guard app. */}
      <Route
        path="/display"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <Display />
          </Suspense>
        }
      />
      <Route
        path="/reset-password"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <ResetPassword />
          </Suspense>
        }
      />
      <Route
        path="/changer-mot-de-passe"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <ForceChangePassword />
          </Suspense>
        }
      />
      <Route
        path="/unsubscribe"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <Unsubscribe />
          </Suspense>
        }
      />
      <Route
        path="/demo"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <Demo />
          </Suspense>
        }
      />
      <Route
        path="/trust"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <TrustCenter />
          </Suspense>
        }
      />
      <Route
        path="/trust-center"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <TrustCenter />
          </Suspense>
        }
      />
      <Route
        path="/exercer-mes-droits"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <ExercerMesDroits />
          </Suspense>
        }
      />
      <Route
        path="/rgpd"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <ExercerMesDroits />
          </Suspense>
        }
      />
      <Route
        path="/audit"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <AuditAccess variant="audit" />
          </Suspense>
        }
      />
      <Route
        path="/rls"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <AuditAccess variant="rls" />
          </Suspense>
        }
      />
      <Route
        path="/app/:slug"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <TenantApp />
          </Suspense>
        }
      />
      <Route
        path="/review/:slug"
        element={
          <Suspense fallback={<LoadingSpinner />}>
            <ReviewRedirect />
          </Suspense>
        }
      />
      <Route
        path="/license"
        element={
          <ProtectedRoute>
            <Suspense fallback={<LoadingSpinner />}>
              <LicenseActivation />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-portal"
        element={
          <ProtectedRoute>
            <RoleGuard roles={['super_admin']}>
              <Suspense fallback={<LoadingSpinner />}>
                <AdminPortal />
              </Suspense>
            </RoleGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-portal/monitoring"
        element={
          <ProtectedRoute>
            <RoleGuard roles={['super_admin']}>
              <Suspense fallback={<LoadingSpinner />}>
                <TenantsMonitoring />
              </Suspense>
            </RoleGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-portal/z-recompute"
        element={
          <ProtectedRoute>
            <RoleGuard roles={['super_admin']}>
              <Suspense fallback={<LoadingSpinner />}>
                <ZRecompute />
              </Suspense>
            </RoleGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-portal/tpe-monitoring"
        element={
          <ProtectedRoute>
            <RoleGuard roles={['super_admin']}>
              <Suspense fallback={<LoadingSpinner />}>
                <TpeMonitoring />
              </Suspense>
            </RoleGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-portal/installation"
        element={
          <ProtectedRoute>
            <RoleGuard roles={['super_admin']}>
              <Suspense fallback={<LoadingSpinner />}>
                <InstallationTools />
              </Suspense>
            </RoleGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-portal/monnayeurs"
        element={
          <ProtectedRoute>
            <RoleGuard roles={['super_admin']}>
              <Suspense fallback={<LoadingSpinner />}>
                <CashRecyclerFleet />
              </Suspense>
            </RoleGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-dashboard-v2"
        element={
          <ProtectedRoute>
            <RoleGuard roles={['super_admin']}>
              <Suspense fallback={<LoadingSpinner />}>
                <AdminDashboardV2 />
              </Suspense>
            </RoleGuard>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin-portal/reseller/:id"
        element={
          <ProtectedRoute>
            <RoleGuard roles={['super_admin']}>
              <Suspense fallback={<LoadingSpinner />}>
                <ResellerDetailPage />
              </Suspense>
            </RoleGuard>
          </ProtectedRoute>
        }
      />
    </>
  );
}
